// extracted by mini-css-extract-plugin
export default {"resultImage":"XALVc0DciEm4IKT66StI","resultTitle":"UUcpQOEZoCAO6KN1PHOK","resultText":"eH8blwsm16kJup4Q0Hy1"};